module.exports = __webpack_public_path__ + "static/media/remote-key-dispensing-banner2.4a35010b.png";